import * as React from "react";

import { Chip } from "mpulse-design-system";

import AudioStatus from "../../utils/enums/AudioStatus";
import constants from "../../constants";

const AudioStatusChip = ({ status }) => {
  return (
    <Chip
      label={constants.audio.statuses[status]}
      type={
        status === AudioStatus.APPROVED
          ? "success"
          : status === AudioStatus.READY_FOR_RECORDING
          ? "warning"
          : status === AudioStatus.READY_FOR_REVIEW
          ? "info"
          : status === AudioStatus.REJECTED
          ? "error"
          : "default"
      }
    />
  );
};

export default AudioStatusChip;
